import { useState } from "react";
import { Linkedin, MessageSquare, Link2, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

const hasNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

export const liveShareUrl = (mode = "live") => `${window.location.origin}/#${mode === "replay" ? "replay" : "live-now"}`;
export const liveShareText = (title, mode = "live") => (mode === "replay"
  ? `Catch the replay: ${title || "Friday Conversations"} — Friday Conversations. Watch here: ${liveShareUrl(mode)}`
  : `We're live now: ${title || "Friday Conversations"} — Friday Conversations. Watch here: ${liveShareUrl(mode)}`);

const pill = "inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-xs font-medium text-foreground shadow-sm transition-colors hover:border-primary hover:text-primary";

export default function LiveShareBar({ title, className = "", testPrefix = "live-share", mode = "live" }) {
  const [copied, setCopied] = useState(false);
  const url = liveShareUrl(mode);
  const text = liveShareText(title, mode);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied — paste it anywhere");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy. Long-press the address bar to copy the link.");
    }
  };

  const nativeShare = async () => {
    try { await navigator.share({ title: title || (mode === "replay" ? "Friday Conversations — replay" : "Friday Conversations — live now"), text, url }); } catch { /* user dismissed */ }
  };

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={`${testPrefix}-bar`}>
      <span className="text-xs font-medium text-muted-foreground">{mode === "replay" ? "Share the replay:" : "Pull a friend in:"}</span>
      <a href={`sms:?&body=${encodeURIComponent(text)}`} className={pill} data-testid={`${testPrefix}-text`}>
        <MessageSquare className="h-3.5 w-3.5" />Text
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className={pill} data-testid={`${testPrefix}-linkedin`}>
        <Linkedin className="h-3.5 w-3.5 text-[#0A66C2]" />LinkedIn
      </a>
      <button type="button" onClick={copy} className={pill} data-testid={`${testPrefix}-copy`}>
        {copied ? <Check className="h-3.5 w-3.5 text-emerald-600" /> : <Link2 className="h-3.5 w-3.5" />}
        {copied ? "Copied" : "Copy link"}
      </button>
      {hasNativeShare && (
        <button type="button" onClick={nativeShare} className={pill} data-testid={`${testPrefix}-native`}>
          <Share2 className="h-3.5 w-3.5" />Share…
        </button>
      )}
    </div>
  );
}
